export function buildSiteSearchUrl(action: string | null, currentUrl: string, query: string, fields: Iterable<[string, unknown]>): string | null {
  try {
    const current = new URL(currentUrl);
    const url = new URL(action?.trim() || "/", current);
    if (!['http:', 'https:'].includes(url.protocol) || url.origin !== current.origin) return null;
    url.search = "";
    url.hash = "";
    const entries = Array.from(fields);
    const searchField = entries.some(([key]) => key === "q") ? "q" : "s";
    for (const [key, value] of entries) {
      if (key === "s" || key === "q" || key === "sf_search" || typeof value !== "string" || !value) continue;
      url.searchParams.set(key, value);
    }
    url.searchParams.set(searchField, query.trim());
    url.searchParams.set("sf_search", "1");
    return url.toString();
  } catch { return null; }
}
